import React from 'react';
import { Box, Stack } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { LenderRetailActivityDealerRowViewModel, LenderRetailActivityStateRowViewModel } from '../../../api/types';
import { LenderRetailActivityReportInput } from '../../../types';
import { GeographicBreakdownMap } from './GeographicBreakdownMap';
import { DealerActivityTable } from './DealerActivityTable';

interface Props {
  stateRows: LenderRetailActivityStateRowViewModel[];
  dealerRows: LenderRetailActivityDealerRowViewModel[];
  dealerTotalCreditApps: number;
  dealerTotalUnits: number;
  input: LenderRetailActivityReportInput;
  isStateLoading?: boolean;
  isDealerLoading?: boolean;
}

export const CreditApps = ({
  stateRows,
  dealerRows,
  dealerTotalCreditApps,
  dealerTotalUnits,
  input,
  isStateLoading,
  isDealerLoading,
}: Props) => (
  <CardContainer title="Credit Apps">
    <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
      <GeographicBreakdownMap rows={stateRows} loading={isStateLoading} />
      <DealerActivityTable
        rows={dealerRows}
        input={input}
        totalCreditApps={dealerTotalCreditApps}
        totalUnits={dealerTotalUnits}
        loading={isDealerLoading}
      />
    </Box>
  </CardContainer>
);
